import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonYporroi';
const args = {};

export class OligonYporroi extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
